import { useCallback } from 'react';

import { usePromiseSnackbar } from '@/hooks/usePromiseSnackbar';
import useSafeguardConfirmationDialog from '@/sections/Dialog/SafeguardConfirmation';
import { TrainingProjectsDocument } from '@/sections/Overview/Training/__generated__/queries.generated';

import { useDeleteTrainingProjectMutation } from './__generated__/mutation.generated';

function useDeleteTrainingProject(id: string, name: string) {
  const promiseSnackbar = usePromiseSnackbar();
  const [deleteProject] = useDeleteTrainingProjectMutation();
  const safeguardConfirmationDialog = useSafeguardConfirmationDialog();

  return useCallback(async () => {
    const confirmed = await safeguardConfirmationDialog({
      title: 'Delete Training Project',
      okText: 'Delete',
      prompt: 'Are you sure you want to delete this training project? This cannot be undone.',
      validationText: name,
      validationHint: 'Training project name',
    });

    if (confirmed) {
      promiseSnackbar(
        deleteProject({
          variables: { id },
          refetchQueries: [TrainingProjectsDocument],
        }),
      );
    }
  }, [id, name, deleteProject, safeguardConfirmationDialog, promiseSnackbar]);
}

export { useDeleteTrainingProject };
